export enum ReservedIpMeta {
  MODEL = "reservedip",
  PK = "id",
}
